<template>
  <div class="chapter">
    <div class="text-wrapper">
      <slot name="header"></slot>
      <slot name="text"></slot>
      <slot name="button"></slot>
    </div>
    <div class="image-wrapper">
      <slot name="image"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChapterRight",
};
</script>

<style lang="scss" scoped>
@import "../scss/shared";

.chapter {
  @include mobile {
    flex-direction: column-reverse;
  }
}
</style>
